 <!-- Content Header (Page header) -->
 <section class="content-header">
  <div class="content-header">
     <div class="container-fluid">
       <div class="row mb-2">
         <div class="col-sm-6">
             <h3>Add Fuel Type</h3>
         </div>
         <div class="col-sm-6">
           <ol class="breadcrumb float-sm-right">
             <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
             <li class="breadcrumb-item"><a routerLink="/settings/fuel-types-list"><i class="fa fa-list-ul"></i>&nbsp;View Fuel Types</a></li>
             <li class="breadcrumb-item active">Add Fuel Type</li>
           </ol>
         </div><!-- /.col -->
       </div><!-- /.row -->
     </div><!-- /.container-fluid -->
 </div>
 </section>
   <!-- /.content-header -->
 <section class="content">
 <div class="container-fluid">
 <div class="card">
     <div class="card-header">
       <h3 class="card-title">Add Fuel Type</h3>
       <!--Error Message-->
       <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          <span [innerHTML]="errorMessage"></span>
        </div>
        <!--Success Message-->
        <div class="alert alert-success" role="alert" *ngIf="successMessage">
          {{successMessage}}
        </div>
     </div>
     <!-- /.card-header -->
     <div class="card-body">
         <form [formGroup]="form" (ngSubmit)="handleSubmit()">
             <div class="row clearfix">
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Fuel Type:<span style="color:red;">*</span></label>
                         <input type="text" formControlName="fuel_type" class="form-control" placeholder="Fuel Type" value="">
                         <span *ngIf="submitted && form.get('fuel_type')?.hasError('required')" style="color:red"> <strong>This field is required!</strong></span>
                     </div>
                 </div>
             </div>

             <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Processing...
              </button>
              <ng-template #showSaveBtn>
                  <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Save</button>
              </ng-template>
         </form>
     </div>
     <!-- /.card-body -->
 </div>
 </div>
 </section>
